import * as studentActions from '../actions/students-actions';
import { MergeUtilities } from './../utilities/merge-utilities';
import { PatchUtilities } from './../utilities/patch-utilities';
export interface IStudentState {
  loading: boolean;
  loaded: boolean;
  studentEntities: object;
  loadedProjection: object;
  sort: object;
  dimensions: object;
}

export const initialState: IStudentState = {
  loading: false,
  loaded: false,
  studentEntities: {},
  loadedProjection: {},
  sort: {},
  dimensions: {},
};

export function reducer(state: IStudentState = initialState, action: studentActions.StudentAction): IStudentState {
  switch (action.type) {
    case studentActions.LOAD_ACADEMIC_STUDENTS: {
      return { ...state, loading: true };
    }

    case studentActions.LOAD_ACADEMIC_STUDENTS_SUCCESS: {
      const studentList = action.payload;

      const studentEntities = studentList.reduce(
        (studentEntities: { [id: number]: any }, student) => {
          return { ...studentEntities, [student._id]: student };
        },
        { ...state.studentEntities },
      );

      return {
        ...state,
        loading: false,
        loaded: true,
        studentEntities,
      };
    }

    case studentActions.BULK_UPDATE_ACADEMIC_STUDENTS_SUCCESS: {
      const { patches } = action.payload;
      const studentEntities = patches.reduce(
        (studentEntities, { _ids, patch }) => {
          _ids.forEach(_id => {
            if (studentEntities[_id]) {
              const newPatch = PatchUtilities.validatePatch(patch, _id);
              studentEntities[_id] = MergeUtilities.deepMergeObjs(studentEntities[_id], newPatch);
            }
          });
          return studentEntities;
        },
        { ...state.studentEntities },
      );
      return { ...state, studentEntities };
    }

    case studentActions.LOAD_ACADEMIC_STUDENTS_FAIL: {
      return { ...state, loading: false, loaded: false };
    }

    case studentActions.UPDATE_ACADEMIC_STUDENTS_PROJECTION_SUCCESS: {
      const loadedProjection = action.payload;
      return { ...state, loadedProjection };
    }

    case studentActions.UPDATE_ACADEMIC_STUDENTS_PROJECTION_FAIL: {
      return { ...state };
    }

    case studentActions.UPDATE_ACADEMIC_STUDENTS_SORT: {
      const sort = action.payload;
      return { ...state, sort };
    }

    case studentActions.UPDATE_ACADEMIC_STUDENTS_DIMENSIONS: {
      const dimensions = action.payload;
      return { ...state, dimensions };
    }

    default:
      return state;
  }
}
